import React from 'react';
import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";
import {Button} from "reactstrap";
import GapTimers from "../../../../../components/Collections/GapTimers";

const breadcrumbStatic = [{
	name: 'New Hires',
	url: '/admins/new_hires',
	icon: 'dashboard'
}];

export default class New_Hires extends Framework.Components.View {

	constructor(props) {
		super(props);
	}

	render() {
		return(
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbStatic} history={this.props.history}/>

				<Collections.NewHires/>

			</div>


		)
	}
}